export enum MESSAGE_MASTER_KEYS {
  /** 個別設定 */
  CUSTOM = 'CUSTOM',

  // WARN
  /** 在留期間を当日以降を選択してください。 */
  在留期間が過去日警告 = 'W_025',
  /** [エリア検索 照合ID期限日] 期限日が超過しています。 */
  W_033 = 'W_033',
  // INFO
  /** 該当する商談で絞り込んでいます */
  I_012 = 'I_012',
  /** 入力内容を保存しました */
  I_013 = 'I_013',
  /** {0}を削除しました */
  I_014 = 'I_014',
  /** メールを送信しました */
  I_015 = 'I_015',
  /** テンプレートを申請しました */
  I_016 = 'I_016',
  /** テンプレートを下書き保存しました */
  I_017 = 'I_017',
  /** API規制中です */
  I_020 = 'I_020',
  /** 該当するメールで絞り込んでいます */
  I_021 = 'I_021',
  /** アクションが登録上限数（6件）です。不要なアクションを削除してから、新しく追加してください。 */
  I_022 = 'I_022',
  /** 対象のデータは変更されています。 */
  I_030 = 'I_030',
  /** 許諾メールを再送信し、入力内容を保存しました */
  I_046 = 'I_046',

  /** メール受信を承諾しました*/
  M_0001 = 'M_0001',
  /** メール送信を停止しました*/
  M_0002 = 'M_0002',
  /** 配信を再開したい場合は、店頭でお手続きをお願いいたします。*/
  M_0003 = 'M_0003',
  /** お客様の情報保持と、当社または他社が提供する商品・サービスおよび\nキャンペーンについてのご案内（メールや電話を含む）することを承諾\nします。 */
  M_0004 = 'M_0004',
  /** ・非対面での情報取得で、メールの宛先が記録されています。\n・メールを送信する許可を取得するメールを送信します。\nお客様がメール内リンクから送信許可を承諾しない限りメールの宛先は\n使用できません。\n\n送信許可の承諾を得るメールを送信しない場合は、メール宛先を削除して\nから保存してください。 */
  M_0005 = 'M_0005',
  /** ご利用ありがとうございます*/
  M_0007 = 'M_0007',
  /** ページが見つかりませんでした。\nご指定のURLに誤りがあるか、お探しのページが削除された可能性があります。\n\n配信停止または再開をご希望の場合は、配信元の店舗へご連絡いただき配信のお手続きをお願いいたします。*/
  M_0008 = 'M_0008',
  /** 店舗からのメールの受信の承諾 */
  M_0009 = 'M_0009',
  /**お客さまより新しく取得する情報は、以下承諾を継続的に得たものとして更新し4年間保持します。<br><br>お客様の情報保持と、当社または他社が提供する商品、サービスおよびキャンペーンについてのご案内メールを受信することを承諾します。<br><br>上記の内容でよろしければ「承諾する」を選択ください。 */
  M_0010 = 'M_0010',
  /** 配信を再開したい場合は、店頭でお手続きをお願いいたします。*/
  M_0011 = 'M_0011',
  /** 対面 */
  /** お客様から取得する情報は、お問い合わせへの対応のほか、当社が取り扱う商品・サービス等のご案内（メールや電話を含む）に利用します。お客様の情報は機密を保持し、4年間保存します。*/
  M_0012 = 'M_0012',
  /** 非対面 */
  /** お客様から取得する情報は、お問い合わせへの対応のほか、当社が取り扱う商品・サービス等のご案内（メールや電話を含む）に利用します。お客様の情報は機密を保持し、4年間保存します。*/
  M_0013 = 'M_0013',
  /** 情報修正 */
  /** お客様から取得する情報は、お問い合わせへの対応のほか、当社が取り扱う商品・サービス等のご案内（メールや電話を含む）に利用します。お客様の情報は機密を保持し、4年間保存します。*/
  M_0014 = 'M_0014',
  /** 表示するデータがありません */
  M_0015 = 'M_0015',
  /** 来店予約を利用できる店舗ではありません */
  M_0016 = 'M_0016',
  /** 上記プルダウンから店舗を選択するとここにデータが表示されます */
  M_0017 = 'M_0017',
  /** 来店予約を利用できる店舗はありません */
  M_0018 = 'M_0018',
  /** ステータス更新対象の商談・商品はありません */
  M_0019 = 'M_0019',
  /** ステータスの更新に失敗したため登録連携できませんでした。もう一度お試しください。 */
  M_0020 = 'M_0020',
  /** ※過去日のため本項目は集計対象外 */
  M_0021 = 'M_0021',
  /** メッセージ概要：パーミッションモーダル情報保持許諾対面メッセージ */
  M_0022 = 'M_0022',
  /** メッセージ概要：パーミッションモーダル情報保持許諾非対面メッセージ */
  M_0023 = 'M_0023',
  /** メッセージ概要：受信の承諾画面送信/配信元情報 */
  M_0024 = 'M_0024',

  // ERROR
  /** 必須項目です **/
  E_S001 = 'E_S001',
  /** ${0}文字以上入力してください **/
  E_S002 = 'E_S002',
  /** ${0}文字以内で入力してください **/
  E_S003 = 'E_S003',
  /** 使用できない文字が含まれています **/
  E_S004 = 'E_S004',
  /** 電話番号が不正です **/
  E_S005 = 'E_S005',
  /** 保存可能な枚数（${0}枚）を超えています **/
  E_S006 = 'E_S006',
  /** 保存可能な枚数は${0}枚までです **/
  E_S007 = 'E_S007',
  /** 利用可能期間をすべて入力してください。 **/
  E_S008 = 'E_S008',
  /** 利用可能期間を正しく入力してください。 */
  E_S009 = 'E_S009',
  /** 開始日には終了日以前の日付を指定してください。 */
  E_S010 = 'E_S010',
  /** 開始日には本日以降の日付を指定してください。 */
  E_S011 = 'E_S011',
  /** ${0}を指定してください。*/
  E_S012 = 'E_S012',
  /** ${0}が${1}文字を超えています。*/
  E_S013 = 'E_S013',
  /** ${0}を入力してください。 */
  E_S014 = 'E_S014',
  /** ${0}に使用できない文字が含まれています */
  E_S015 = 'E_S015',
  /** 使用できない文字が含まれています */
  E_S016 = 'E_S016',
  /** 使用できない文字列が含まれています */
  E_S017 = 'E_S017',
  /** ${0}に使用できない文字列が含まれています */
  E_S018 = 'E_S018',
  /** 入力内容は保存されましたが、メール受信の許諾メールが送信されてない可能性があります。 */
  E_S019 = 'E_S019',
  /** ${0}に使用できない文字列(${1})が含まれています */
  E_S020 = 'E_S020',
  /** PCM-P-0246-0 期間外エラー */
  E_S021 = 'E_S021',
  /** PCM-P-0246-0 未来日エラー */
  E_S022 = 'E_S022',
  /** PCM-P-0246-0 過去日エラー */
  E_S023 = 'E_S023',
  /** 処理中にお客さま情報が更新されたため、許諾メール再送信できませんでした */
  E_S024 = 'E_S024',
  /** PCM-P-0217-0 年齢/人数の「${0}」は${1}文字以内で入力してください */
  E_S025 = 'E_S025',
  /** PCM-P-0217-0 年齢/人数の「${0}」を入力してください */
  E_S026 = 'E_S026',
  /** [エリア検索 登録連携モーダル] 入力不備があるため、エリア検索へ移動できません。 */
  E_S027 = 'E_S027',
  /** [エリア検索 登録連携モーダル] 複数商品が入力されています。一度保存し、商品の編集からエリアチェックを行ってください。 */
  E_S028 = 'E_S028',
  /** [エリア検索 登録連携モーダル] 登録からの最大保持期限（1,460日）を超過しています。${0}～{1}の範囲で選択してください。 */
  E_S029 = 'E_S029',
}

export default MESSAGE_MASTER_KEYS;
